<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><a id="page_i"></a><a id="otherfm"></a>Praise for <em>The Devil Tree:</em></p>
<p class="noindenta">“Flawless . . . A strong, meaningful voice, adding something vital to the riches of the modern novel.”</p>
<p class="right1">—<em>The Times</em> (London)</p>
<p class="noindenta">“One of our finest and most important writers . . . masterful.”</p>
<p class="right1"><em>—The Oregonian</em> (Portland)</p>
<p class="noindenta">“Kosinski is, one is sure, related in some crazy way to Hesse. . . . An unusual writer—so consistently faithful to his own peculiar talent.”</p>
<p class="right1"><em>—Cincinnati Enquirer</em></p>
<p class="noindenta">“Jerzy Kosinski’s prose is in itself so remarkable—terse and hardedged but still supple and fluid—that it seems impossible he could ever fail or bore his readers. . . . Kosinski is one of our most valuable and exciting writers, and <em>The Devil Tree</em> will undoubtedly find a wide and appreciative audience.”</p>
<p class="right1">—<em>Saturday Review</em></p>
<p class="noindenta">“Stunning . . . powerful and affecting.”</p>
<p class="right1"><em>—Publishers Weekly</em></p>
<p class="noindent"><a id="page_ii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// otherfm.vue?c0a586ce